<template>
  <div class="modalWrapper">
    <div class="modalBlock">
      <div class="PaymentFailedContainer">
        <div class="PaymentFailed"></div>
      </div>
      <div class="confirmTitle">{{ title }}</div>
      <div class="errorText">{{ text }}</div>

      <div class="actionWrapper">
        <div class="confirmActions">
          <div class="confirmBtn" @click="try_again_or_continue">
            {{ confirmBtnText }}
          </div>
          <div class="confirmBtn cancelBtn" @click="backToCart">
            {{ cancelBtnText }}
          </div>
          <div class="confirmBtn failBtn" @click="abort">
            {{ failBtnText }}
          </div>
        </div>
      </div>
    </div>
    <div class="modalBackdrop"></div>
  </div>
</template>
<script>
export default {
  name: "payment",
  props: {
    title: String,
    text: String
  },
  computed: {
    confirmBtnText() {
      return this.$t(`payment.try_again`);
    },
    cancelBtnText() {
      return this.$t(`payment.back`);
    },
    failBtnText() {
      return this.$t(`payment.abort`);
    }
  },
  methods: {
    abort() {
      this.$emit("abort");
    },
    backToCart() {
      this.$emit("back_to_cart");
    },
    try_again_or_continue() {
      this.$emit("try_again");
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.modalWrapper {
  height: 100vh;
  width: 100vw;
  background: rgba(37, 37, 37, 0.12);
  position: fixed;
  z-index: 1200;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.modalBackdrop {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1250;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.modalBlock {
  position: fixed;
  z-index: 1300;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 751px;
  height: 600px;
  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 4px 4px 25px #00000033;
  border-radius: var(--component_modals_payment_modalBlock_border-radius);
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 30px;
  color: black;
  justify-content: space-around;
}
.actionWrapper {
  display: flex;
  justify-content: center;
}
.confirmActions {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  width: 60%;
  height: 330px;
  padding-bottom: 50px;
}
.confirmBtn {
  width: 100%;
  height: 70px;
  border: var(--component_modals_payment_confirmBtn_border);
  border-radius: var(--component_modals_payment_confirmBtn_border-radius);
  color: var(--component_modals_payment_confirmBtn_color);
  letter-spacing: 1.84px;
  font-family: var(--component_modals_payment_confirmBtn_font-family);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--component_modals_payment_confirmBtn_font-size);
  background: var(--component_modals_payment_confirmBtn_background);
  padding: var(--component_modals_payment_confirmBtn_padding);
  text-transform: var(--component_modals_payment_confirmBtn_text-transform);
}

.cancelBtn {
  background: var(--component_modals_payment_cancelBtn_background);
  color: var(--component_modals_payment_cancelBtn_color);
}
.failBtn {
  background: var(--component_modals_payment_failBtn_background);
  color: var(--component_modals_payment_failBtn_color);
}
.confirmTitle {
  color: var(--component_modals_payment_confirmTitle_color);
  font-size: var(--component_modals_payment_confirmTitle_font-size);
  font-family: var(--component_modals_payment_confirmTitle_font-family);
  padding: 0 0 10px 0;
  text-transform: uppercase;
}
.errorText {
  color: var(--component_modals_payment_errorText_color);
  font-size: 20px;
  font-family: var(--app_font-family-light);
  padding: 0 0 20px 0;
}
.confirmHeader {
  font-size: 26px;
  margin: 30px 0;
}

.PaymentFailedContainer {
  padding: 40px 0 30px 0;
}
.PaymentFailed {
  height: 110px;
  background-image: var(
    --component_modals_payment_PaymentFailed_background-image
  );
  background-position: center;
  background-repeat: no-repeat;
}
</style>
